<template>
  <!--
    쿠폰 메시지 관리 화면 
    퍼블: PubUI_FOMB10308PC
  -->
  <div class="content-box">
    <!-- 사용자 정보 영역 -->
    <HconMyPageUsrInfo />

    <div class="sub-wrapper">
      <!-- 마이페이지 왼쪽 사이드 메뉴 영역 -->
      <HconMyPageSideMenu />

      <div class="sub-contents">
        <!-- 화면 안내문구 영역 -->
        <div class="border-title title">
          <h4 class="title">쿠폰 메시지 관리<span class="desc">주문서 작성 시 사용할 나만의 쿠폰 메시지를 등록·관리할 수 있습니다.</span></h4>
          <div class="button-box">
            <nuxt-link to="/pc/mypage/coupon-message/create" class="btn btn-outline shrink0">메시지 등록</nuxt-link>
          </div>
        </div>

        <!-- 총 건수 표시 영역 -->
        <div class="contents-title-wrap mt40 button">
          <div class="contents-title">
            <h5 class="font-bold">총 <span class="text-green">{{ msgListCnt }}</span>건<span class="font-normal text-gray ml8">(최대 20건)</span></h5>
          </div>
        </div>

        <div class="contents-detail-wrap">
          <table class="tbl-type">
            <caption>쿠폰 메시지 관리 내역</caption>
            <colgroup>
              <col style="width: 6%;">
              <col style="width: 20%;">
              <col style="width: auto;">
              <col style="width: 15%;">
              <col style="width: 10%;">
            </colgroup>
            <thead>
              <tr>
                <th scope="col">번호</th>
                <th scope="col">제목</th>
                <th scope="col">내용</th>
                <th scope="col">등록일시</th>
                <th scope="col">삭제</th>
              </tr>
            </thead>
            <tbody v-if="msgList.length > 0">
              <tr v-for="(item, index) in msgList" :key="index">
                <td>{{ msgListCnt - index }}</td>
                <td class="left">
                  <NuxtLink :to="`/pc/mypage/coupon-message/detail/${item.cpnMsgSeq}`" class="link-underline font-bold">{{ item.cpnMsgTtl }}</NuxtLink>
                </td>
                <td class="left">
                  <NuxtLink :to="`/pc/mypage/coupon-message/detail/${item.cpnMsgSeq}`" class="link-underline ellips">{{ item.cpnMsgCntn }}</NuxtLink>
                </td>
                <td class="fs14 text-gray02">{{ HconCommonUtils.format.dateTimeNoSec(item.frstRegDtm) }}</td>
                <td>
                  <button type="button" class="btn btn-outline xs" @click="handleMsgDeleteAlert(item.cpnMsgSeq)">삭제</button>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5" class="nodata">쿠폰메세지 내역이 없습니다.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> 
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import HconMyPageUsrInfo from '@/components/corner/pc/HconCornerUserInfoPC.vue';
import HconMyPageSideMenu from '@/components/corner/pc/HconCornerMypageSideMenuPC.vue';
import { HconCommonUtils } from "@/utils/hcon-common-utils";
import type { MsgDto, MsgDeleteDto } from '~/types/mypage/backend-dto-types';
import { MEMBER_CODE } from '@/constants/hconMessageConstants';

const fetchBuilder  = useHconFetchBuilder();

// 팝업
const {
  showAlert,
  showConfirm
} = usePopup();

// 쿠폰 메시지 조회 API 결과 값
const msgList = ref<MsgDto[]>([]);
const msgListCnt = ref(0);

// 삭제하는 쿠폰 메시지
const deleteMsgData = ref<MsgDeleteDto>();

const getMsgList = () => {
  const msgListFetcher =
    fetchBuilder.get<AjaxResult<MsgDto[]>>('/api/v1/mypage/coupon-message/list')
    .progressMessage("잠시만 기다려주세요...")
    .build()
    .execute()
    .then((result) => {
      if(result.resultCode != '200') {
        showAlert(result.resultMessage);
      } else {
        msgList.value = result.data;
        msgListCnt.value = result.data.length;
      }
  });
}

const handleMsgDeleteAlert = async (msgSeqNo: number) => {
  const chkDel = await showConfirm({
    title: '쿠폰 메시지 삭제',
    message: MEMBER_CODE.ALT_HCON_9116, // '선택하신 쿠폰 메시지를 삭제하시겠습니까?'
    confirmText: '확인',
    cancelText: '취소'
  })

  if (chkDel) {
    // 삭제 정보 세팅
    deleteMsgData.value = {
      cpnMsgSeq: msgSeqNo
    }
  
    const fetchBuilderResult = await fetchBuilder.post<AjaxResult<MsgDto>>('/api/v1/mypage/coupon-message/delete')
      .body(deleteMsgData.value)
      .progressMessage("잠시만 기다려주세요...")
      .build()
      .execute()
      .then(async (result) => {
        if(result.resultCode != '200') {
          showAlert(result.resultMessage);
        } else {
          const res = await showConfirm({
            title: '메시지 삭제 완료',
            message: MEMBER_CODE.ALT_HCON_9186, // 'MY 메시지가 삭제되었습니다.'
            confirmText: '확인',
            showCancelButton: false,
          });
  
          if (res) {
            getMsgList();
          }
        }
      })
  }
}


onMounted(() => {
  getMsgList();
});

</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/order-hcon.scss" as *;
@use "@/assets/scss/pc/mypage-hcon.scss" as *;
</style>